import React from 'react';
import strings from '../../components/Language';
import AuthSubHeader from '../../components/Layout/AuthSubHeader';
import api from '../../config/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import OtpInput from 'react-otp-input';
import { Button } from 'antd';


class ForgotPasswordScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
            isLoading: false,
            otpIsLoading: false,
            is_send_otp_disabled: false,
            timeLeft: 300,
            store_otp_code: null,

            mobile: '',
            otp_code: '',
            name: '',
            ic_no: '',
            email: '',
            newPassword: '',
            confirm_password: '',
            is_accept: false,
            ref_code: null,
        }
        this.timer = null;
    }

    async componentDidMount() {
    }

    // Start the countdown timer
    startTimer = () => {
        this.timer = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.timeLeft <= 1) {
                    this.clearTimer();
                    this.setState({ is_send_otp_disabled: false, timeLeft: 300 });
                    return { timeLeft: 0 };
                }
                return { timeLeft: prevState.timeLeft - 1 };
            });
        }, 1000);
    };

    // Clear the timer
    clearTimer = () => {
        if (this.timer) {
            clearInterval(this.timer);
        }
    };

    // Format time in mm:ss
    formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`;
    };

    RequestOTP() {
        var self = this;
        self.setState({ is_send_otp_disabled: true })
        self.setState({ otpIsLoading: true })
        // self.startTimer();
        axios({
            method: 'POST',
            url: api.ForgetPasswordOTP,
            data: {
                mobile: self.state.mobile,
                lang: self.state.lang
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            self.setState({ is_send_otp_disabled: false });
            self.setState({ otpIsLoading: false });
            if (response.data.error == 202 || response.data.error == '202') {
                if (response.data.errors && response.data.errors.length != 0) {
                    self.setState({ errorMessage: response.data.errors });
                } else {
                    toast.error(response.data.message);
                }
            } else {
                toast.success(response.data.message);
                self.startTimer();
                self.setState({
                    is_send_otp_disabled: true,
                    store_otp_code: response.data.otp_code
                });
            }
        }).catch(function (error) {
            self.setState({ otpIsLoading: false });
            self.setState({ is_send_otp_disabled: false });
            toast.error(strings['no_internet']);
            self.showAlert();
        });
    }

    handlePasswordChange = (data) => {
        this.setState({ newPassword: data });
    };

    handleConfirmPasswordChange = (data) => {
        this.setState({ confirm_password: data });
    };

    onPress() {
        var self = this;
        if (this.state.otp_code.length < 6) {
            toast.error(strings['OTP must be 6 digits'])
            return false;
        }
        if (this.state.newPassword !== this.state.confirm_password) {
            toast.error(strings['Password and Confirm Password not match']);
            return false;
        }


        self.setState({ isLoading: true })
        axios({
            method: 'POST',
            url: api.ResetPassword,
            data: {
                mobile: self.state.mobile,
                otp_code: self.state.otp_code,
                password: self.state.newPassword,
                password_confirmation: self.state.confirm_password,
                lang: self.state.lang,
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            self.setState({ 'isLoading': false })
            if (response.data.error == 202 || response.data.error == '202') {
                if (response.data.errors && response.data.errors.length != 0) {
                    self.setState({ errorMessage: response.data.errors });
                } else {
                    var err_result = response.data.message.split("\r\n");
                    err_result.forEach(data => {
                        if (data) {
                            toast.error(data);
                        }
                    });
                }
            } else {
                toast.success(response.data.message);
                self.props.navigate(`/`);
                return false;
            }
        }).catch(function (err) {            
            toast.error(strings["Invalid Login Credential"]);
            self.setState({ 'isLoading': false });
        });
    }

    render() {
        const { timeLeft } = this.state;
        return (
            <>
                <div className="forgotPassword">
                    <AuthSubHeader data={{ title: "" }} />
                    <main className="reset-container">
                        <h2 id="forgotPassword" className="reset-title">{strings["forgotPassword"]}</h2>

                        <form>
                            <div className="form-group">
                                <label htmlFor="mobileNumPlaceholder" id="mobileNumLabel">{strings["mobileNumLabel"]}<span>*</span></label>
                                <input
                                    onChange={(e) => this.setState({ mobile: e.target.value })}
                                    type="tel"
                                    id="mobileNumPlaceholder"
                                    placeholder={strings["mobileNumPlaceholder"]}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="verificationCodePlaceholder" id="verificationCodeLabel">{strings["verificationCodeLabel"]}<span>*</span></label>
                                <div className="verification-group">
                                    <input
                                        onChange={(e) => this.setState({ otp_code: e.target.value })}
                                        type="text"
                                        id="verificationCodePlaceholder"
                                        placeholder={strings["verificationCodePlaceholder"]}
                                        required
                                    />
                                    <Button onClick={() => this.RequestOTP()} disabled={this.state.is_send_otp_disabled} type="button" id="otpButton" className="otp-button" loading={this.state.otpIsLoading} >
                                        {this.state.is_send_otp_disabled == false ? strings["otpButton"] : this.formatTime(timeLeft)}
                                    </Button>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="digit1" id="passwordLabel">{strings["passwordLabel"]}<span>*</span></label>
                                <div className="password-code">
                                    <OtpInput
                                        value={this.state.newPassword}
                                        onChange={this.handlePasswordChange}
                                        numInputs={6} // Number of OTP input fields
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle="password-input"
                                        inputType='password'
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label id="retypePasswordLabel">{strings["retypePasswordLabel"]}<span>*</span></label>
                                <div className="password-code">
                                    <OtpInput
                                        value={this.state.confirm_password}
                                        onChange={this.handleConfirmPasswordChange}
                                        numInputs={6} // Number of OTP input fields
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle="password-input"
                                        inputType='password'
                                    />
                                </div>
                            </div>

                            <button onClick={() => this.onPress()} type="button" id="forgotPasswordButton" className="reset-button">
                                {strings["forgotPasswordButton"]}
                            </button>
                        </form>
                    </main>
                </div>
            </>
        );
    }
}

export default ForgotPasswordScreen;
